module.exports = __webpack_public_path__ + "static/img/coin-background.550bb89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coin-background.jpg
// module id = Lv54
// module chunks = 1